import { Collection } from 'modules/core/lib/mobx-rest'

import UserPreference from 'modules/notifications/store/models/UserPreference'

class UserPreferences extends Collection<UserPreference> {
  get cacheKey(): string {
    return 'userPreferences'
  }

  model() {
    return UserPreference
  }
}

export default new UserPreferences()
